import { FC } from 'react';

export const ReferralTitle: FC = props => {
    const { children } = props;
    return (
        <h2 className={'g-referral-title'}>{children}</h2>
    )
};
